// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2hFlv","inner":"Form_inner__3ATBD","range":"Form_range__tJ36m","name":"Form_name__31nSi","actions":"Form_actions__31B6A"};